const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        bezEhepartner: 'Ehepartner',
        bezElternteil: 'Elternteil',
        bezGeschwister: 'Geschwister',
        bezLebenspartner: 'Lebenspartner',
        angehoerige: 'Kontaktperson',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        beziehung: 'Beziehung',
        secndBeziehung: '2. Kontaktperson',
        anrede: 'Anrede',
        priority: 'Prioritärer KontaktPerson',
        arbeitgeber: 'Arbeitgeber',
        employment: 'Ich bin',
        company: 'Firma',
        streetAndNumber: 'Strasse und Nr.',
        country: 'Land',
        tel: 'Telefon',
        employed: 'Angestellt',
        unemployedRAV: 'Stellenlos RAV',
        selfEmployed: 'Selbständig',
        keineAngabenArbeitgeber: 'Ich möchte keine Angaben zu meinem Arbeitgeber machen',
        infoText:
            'Wir bitten Sie, falls es sich um einen Unfall handelt, zwingend Ihren Arbeitgeber (falls Sie eine Arbeit nachgehen) anzugeben.',
        behandlungsvereinbarung: 'Behandlungsvereinbarung',
        costAbsorptionTitle: 'Kostenübernahme',
        costAbsorptionText:
            'Gegenüber der Lindenhofgruppe AG sind Sie Schuldner/in der Behandlung. Rechnungen werden elektronisch via das MediData-Netz direkt an die uns bekannt gegebene Krankenkasse oder Versicherung gestellt. Sämtliche Kosten, die nicht durch einen Kostenträger (Versicherung/Kanton) übernommen werden sowie Zusatzleistungen (Wahl einer höheren Behandlungsklasse, Telefongebühren,Getränke usw.) werden Ihnen direkt in Rechnung gestellt. Die elektronische Übermittlung an Sie erfolgt unter Verwendung Ihrer E-Mail-Adresse und Mobilnummer. Die übermittelten Patientendaten unterliegen den gleichen Sicherheitsstandards wie bspw. das E-Banking. Patienten mit Wohnsitz im Ausland und ausländischer Versicherung haben die Konsultation direkt mit der Kreditkarte zu bezahlen.',
        involvementOfThirdPartiesTitle: 'Einbezug von Drittpersonen',
        involvementOfThirdPartiesText:
            'Mit Ihrer Unterschrift ermächtigen Sie die Lindenhofgruppe, die für die Rechnungsstellung erforderlichen Daten bei der zuständigen Versicherung sowie bei Patientinnen/Patienten im Hausarztmodell beim zuständigen Hausarzt, einzuholen und sowohl an die Rechnungsstellende als auch an die mit einem allfälligen Inkasso beauftragte Institution, Betreibungsamt oder Gerichte weiterzuleiten. Im Fall eines alternativen Versicherungsmodells (z.B. Hausarztmodell) sind Sie auch damit einverstanden, dass Angaben zu der/dem von Ihnen gewählten Hausärztin/-arzt eingeholt werden. Die Lindenhofgruppe AG ist verpflichtet, die Gesundheitsdaten in Erfüllung der gesetzlichen und behördlichen Auflagen zu bearbeiten und an Dritte weiterzugeben (z.B. für die Rechnungs- und Wirtschaftlichkeitskontrolle durch die Krankenversicherer). Hiermit erklären Sie sich einverstanden, dass auch Ihre/Ihr zuweisende/r Ärztin/Arzt, Ihr/ Hausärztin-/arzt und gegebenenfalls weitere in Ihre Behandlung einbezogene Gesundheitsfachpersonen Informationen über die aktuelle Behandlung erhalten. Hiermit geben Sie das Einverständnis, dass im Falle eines Zahlungsverzugs die für das Inkasso-, Betreibungs- und Gerichtsverfahren erforderlichen Angaben an die Inkassostelle, das Betreibungsamt und die Gerichte weitergegeben werden.',
        qualityControlsTitle: 'Qualitätskontrollen',
        qualityControlsText:
            'Nach dem Spitalaustritt wird standardmässig eine Patientenzufriedenheitsbefragung durch ein spezialisiertes Institut durchgeführt. Ausserdem werden punktuell weitere Befragungen vorgenommen. Die Angaben werden unter Einhaltung des Datenschutzes in anonymisierter Form ausgewertet. Die Teilnahme ist freiwillig.',
        lawAndPlaceOfJurisdictionTitle: 'Anwendbares Recht und Gerichtsstand',
        lawAndPlaceOfJurisdictionText:
            'Das Behandlungsverhältnis untersteht schweizerischem Recht. Ausschliesslicher Gerichtsstand ist Bern. Rechtswahl und Gerichtsstand gelten auch für Ansprüche, die direkt gegen den behandelnden Arzt oder die behandelnde Ärztin oder das Personal der Lindenhofgruppe AG erhoben werden.',
        patientInformationCheckboxLabel: 'Ich habe die «{link}» gelesen.',
        patientInformationLabelLink: 'Patienteninformation über Ihre Rechte und Ihre Verantwortung im Spital',
        dataProtectionCheckboxLabel: 'Ich habe die «{link}» gelesen und bin mit deren Geltung einverstanden.',
        dataProtectionLabelLink: 'Datenschutzerklärung',
        treatmentAgreementCheckboxLabel:
            'Ich habe die Behandlungsvereinbarung gelesen und bin mit deren Geltung einverstanden.',
        saveBtnLabel: 'Speichern',
        direktabrechnung: 'Direktabrechung',
        direktabrechnung1:
            'Ich bin mit der Direktabrechnung mit meinem Versicherer und der damit verbundenen elektronischen Deckungsabfrage einverstanden:',
        infoTextDirektabrechnung:
            'Bei Versicherungen welche die Lindenhofgruppe/Orthopädie Sonnenhof KLG keine Verträge abgeschlossen hat, werden die Rechnungen direkt an die Patienten zu Begleichung zugeschickt. Mit dem Rückforderungsbeleg können Sie den Betrag direkt bei der Versicherung zurückfordern.',
        hausArzt: 'Hausarzt',
        keinHausarzt: 'Ich habe keinen Hausarzt',
        kommentare: 'Kommentar oder Upgrade Wünsche',
        kommentarSubTitle:
            'auf Halbprivat/Privat (kostenpflichtig und es wird auf Wunsch einen Kostenvoranschlag gemacht)',
        kommentar: 'Kommentar oder Upgrade Wünsche auf Halbprivat/Privat (kostenpflichtig mit Kostenvorschlag)',
        patientenVerfuegungInfo: 'Patientenverfügung',
        patientenVerfuegungQuestion: 'Haben Sie eine Patientenverfügung?',
        decisionTrue: 'Ja',
        decisionFalse: 'Nein',
        sozialversicherungsnr: 'Sozial­versiche­rungsnr',
        rechnugskopie: 'Ich wünsche eine Rechnungskopie.',
        wohnortversicherung: 'Wohnort / Versicherung',
        fid: 'Ihre Fallnummer',
        persAngaben: 'Persönliche Angaben',
        dateOfBirth: 'Geburtstag',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        language: 'Sprache',
        nationality: 'Nationalität',
        profession: 'Beruf',
        religion: 'Religion',
        zivilWohnsitz: 'Abweichend vom zivilrechtlichen Wohnsitz',
        zivilWohnsitzAdress: 'Abweichend vom zivilrechtlichen Wohnsitz',
        korres: 'Abweichende Korrespondenzadresse',
        korresAdresse: 'Korrespondenzadresse',
        email: 'Email',
        kanton: 'Kanton',
        eAufgebot: 'Elektronisches Aufgebot',
        ePatientenportal: 'Elektronische Kommunikation',
        zivilWohnsitzHelpText:
            'Falls die oben genannte Adresse nicht den zivilrechtlichen Wohnsitz entspricht (Wohnsitz, wo man sich mit der Absicht des dauernden Verbleibens aufhält, wo man seinen Lebensmittelpunkt hat und Steuern zahlt.), hier die korrekte Postleitzahl, Ort und Kanton gemäss zivilrechtlicher Wohnsitz eingeben.',
        eAufgebotHelpText: 'Zustimmung für den Erhalt der Aufgebotsunterlagen in elektronischer Form per Mail.',
        ePatientenportalHelpText:
            'Zustimmung für den Erhalt von zusätzlichen Unterlagen wie Berichte, Bilder und Kopien via Patientenportal.',
        requestedLanguage: 'Gewünschte Korrespondenz­sprache',
        emptyNotAllowed: 'Bitte geben Sie einen Wert an',
        behandlungsgrund: 'Behandlungs­grund',
        versicherung: 'Ver­sicherung',
        unfallDatum: 'Unfalldatum',
        unfallNumber: 'Unfallnummer',
        unfallGemeldet: 'Unfall gemeldet?',
        schadennummer: 'Schaden­nummer',
        nameDerVersicherung: 'Name der Versicherung',
        zusatzVersicherung: 'Zusatz­versicherung',
        cardnr: 'Kartennr.',
        verfuegungsNr: 'Verfügungsnr.',
        expirydate: 'Ablauf­datum',
        versicherungName: 'Name der Ver­sicherung',
        CHWohnort: 'Wohnort / Versicherung',
        versicherungsdeckung: 'Versicherungs­deckung',
        office: 'Telefon Büro',
    },
    __RELATIVE_SOURCE_FILE__
);
